<template>
    <span data-goods-voucher>
        <div class="" v-if="defaultVoucher && defaultVoucher.length" style="background:#fff">
            <div class="detail-item" style="border-top:0.05rem solid #eee">
                <a href="javascript:;" @click.deb="bindShow()">
                    <div class="item-detail-coupon">
                      <div class="detail-coupon">
                        <!--<dl>-->
                          <!--<dt>-->
                          <!--<ul class="detail-coupon">-->
                            <!--<li v-for="vItem in defaultVoucher">-->
                              <!--<span class="coupon"></span>-->
                              <!--<span class="coupon-name">满{{vItem.limitAmount}}减{{vItem.templatePrice}}</span>-->
                              <!--<span class="coupon coupon-right"></span>-->
                            <!--</li>-->
                          <!--</ul>-->
                          <!--</dt>-->
                        <!--</dl>-->
                      </div>
                    </div>
                    <div class="item-more" style=""></div>
                </a>
            </div>

        </div>
        <!-- 弹出层 -->
        <transition name="ncbottom">
            <div class="nctouch-bottom-mask mask-show" v-show="show" ref="layer">
                <!--<div class="nctouch-bottom-mask-bg"  @click="show=false" @touchmove="excludeTouch"></div>-->

                    <div class="nctouch-bottom-mask-block">
                        <div class="nctouch-bottom-mask-top mask-coupons" @touchmove="excludeTouch">
                            <div class="close"><i class="closed" @click="show=false" data-name="优惠券"></i>ကူပြန္</div>
                        </div>
                        <div class="coupons-options">
                            <!--<h4 @touchmove="excludeTouch">可领优惠券</h4>-->
                            <div class="coupons-content" ref='scroll'>
                                <ul>
                                    <li class="coupons-item" v-for="(itemVoucher ,index ) in voucherList">
                                        <a class="item" href="javascript:;"  @click="bindReceiveVoucher(itemVoucher , index)">
                                            <div class="item-left">
                                              <p class="coupons-name" data-name="可购买XX商品">{{itemVoucher.storeName}}</p>
                                              <div class="price"><b>Ks</b><em>{{itemVoucher.templatePrice}}</em><span class="condition" data-name="滿XX可用">ဝယ္ Ks{{itemVoucher.limitAmount}}ေလ်ာ့</span><p class="time" data-name="有效期">သက္တမ္း:{{itemVoucher.useEndTimeText|$convertDate}}</p></div>

                                            </div>
                                            <div class="item-right">
                                                <div class="coupons-text">
                                                    <span class="goto-receive" v-if="!itemVoucher.memberIsReceive" data-name="点击领取">Get Now</span>
                                                </div>
                                                <div class="receive" v-if="itemVoucher.memberIsReceive == 1"></div>
                                            </div>
                                        </a>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </transition>
    </span>
</template>
<script>
//    var ApiUrl = "https://my.zegobird.com:11101/api";

    var posting = false;
    export default {
        props: {
            //显示的所有店铺优惠券，弹出层中显示的是根据登录或者未登录重新获取的优惠卷
            defaultVoucher: {
                type: Array,
                required: false
            },
            //token
            token: {
                type: String,
                required: false
            },
            //店铺id，获取登录后的代金卷需要使用
            storeId: {
                type: Number,
                required: true
            },
            //获取登录后的代金券url地址
            loginedVoucherUrl: {
                type: String,
                default: ApiUrl + '/member/voucher/template/free'
            },
            //未登录的代金券获取地址
            noLoginedVoucherUrl: {
                type: String,
                default: ApiUrl + '/store/voucher?storeId='
            },
            //领券地址
            receiveUrl: {
                type: String,
                default: ApiUrl + "/member/voucher/receive/free"
            }
        },
        /*
         * 自身数据,一定要一个function
         */
        data() {
            return {
                //弹出层开关
                show: false,
                //登录后的代金卷
                loginedVoucherList: [],
                //未登录的代金券
                noLoginedVoucherList: []
            }
        },
        /**
         * 计算属性
         */
        computed: {
            //最终的代金卷列表
            voucherList() {
                //获取默认的代金券列表
                return this.token ? this.loginedVoucherList : this.noLoginedVoucherList;
            }
        },

        /**
         * 生命周期钩子
         */
        beforeCreate() {

        },
        created() {


            if (!ApiUrl) {
                throw new Error("config.js load fail")
            }
            if (this.token) {
                this.loadLoginedVoucher()
            } else {
                this.loadNoLoginedVoucher()
            }
        },
        updated(){

            if (this.show) {
                new IScroll(this.$refs.scroll, {
                    scrollX: false,
                    scrollY: true,
                    click: true
                });
            }




        },
        mounted(){
            var $layer = this.$refs.layer;
            var $body = document.getElementsByTagName("body")[0];
            $body.appendChild($layer);
        },

        /**
         * 自定义方法
         */
        methods: {

            excludeTouch:function(event){
                event.preventDefault();
               console.log("excludeTouch---"+this.show)
                return false ;
            },
            bindShow :function(){
              ga('send', 'event', '选择优惠券按钮', '点击', '按钮点击'); //谷歌锚点
              this.show = true
                console.log("bindShow--"+this.show)
            } ,
            //异步获取登录后的代金券
            loadLoginedVoucher() {
                var self = this

                $.post(this.loginedVoucherUrl, {
                    storeId: self.storeId,
                    token: self.token
                }, function (xhr) {
                    if (xhr.code == 200) {
                        self.loginedVoucherList = xhr.datas.voucherTemplateList
                    }else {
                        alertError(xhr.datas.error);
                    }
                })
            },
            // 异步获取未登录的代金卷
            loadNoLoginedVoucher() {
                var self = this
                $.getJSON(this.noLoginedVoucherUrl + this.storeId, function (xhr) {
                    if (xhr.code == 200) {
                        self.noLoginedVoucherList = xhr.datas.voucherTemplateList
                    } else {
                       alertError(xhr.datas.error);
                    }

                })
            },
            /**
             * 领券
             */
            _receiveVoucher(templateId, index) {

                var self = this
                $.post(this.receiveUrl, {
                    token: self.token,
                    templateId: templateId
                }, function (xhr) {
                    if (xhr.code == 200) {

                        self.voucherList[index].memberIsReceive = 1
                    } else {
                       alertError(xhr.datas.error);
                    }
                })
            },
            //点击领取券
            bindReceiveVoucher(itemVoucher, index) {

                if (itemVoucher.memberIsReceive ) return ;
                if (!this.token) {
                    this.$emit("gologin")
                } else {
                    this._receiveVoucher(itemVoucher.templateId, index)
                }
            }
        }
    }
</script>




// WEBPACK FOOTER //
// src/components/goods-voucher/goods-voucher.vue